'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  organizations: {
    empty: 'Aucune organisation.',
    form: {
      confirmSave: 'Voulez-vous enregistrer les modifications \xE0 cette organisation\xA0?',
      dontSave: 'Ne pas enregistrer',
      eb_id: 'ID Eventbrite',
      parentOrganization: 'Organisation parente',
      save: 'Enregistrer'
    },
    new: 'Ajouter une organisation',
    next: 'Page suivante',
    previous: 'Page précédente',
    sortDirection: {
      asc: 'en ordre croissant',
      desc: 'en ordre décroissant'
    },
    sortOrder: {
      creation: 'date de création',
      modification: 'date de mise à jour',
      name: 'nom'
    },
    subOrganizationOf: 'Incluse dans',
    title: 'Organisations',
    titleBox: {
      help: "Nom de l'organisation"
    },
    total: '%{smart_count} organisation classée par |||| %{smart_count} organisations classées par'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/organizations.js
// module id = 2295
// module chunks = 0